<script>
  import page from "page";
  import { status } from "./status.js";
  import { onMount } from 'svelte';

  var	positionArray  = [], quickLinks  = [];

  function doNavigation(url) {
    window.scrollTo(0,0);
    page(url);
  }

	onMount(() => {

    $status.notification.show = false;
    $status.notification.confirm = false;
  
    var	 hashArray  = [], isActive = '';
    quickLinks = document.querySelectorAll(".menu-list a");

    for (var i=0; i<quickLinks.length; i++){
      hashArray.push(quickLinks[i].href.substring(quickLinks[i].href.indexOf('#')+1));
    }

    for (var i=0; i<hashArray.length; i++){
      positionArray.push(document.getElementById(hashArray[i]).getBoundingClientRect().top);
    }

    document.addEventListener("scroll", scrollHandler, true);
    
    for (var i=0; i<quickLinks.length; i++){
      quickLinks[i].addEventListener('click', function(event){
        document.removeEventListener('scroll', scrollHandler, true);

        isActive = document.querySelectorAll(".menu-list a.is-active")[0];

        if (isActive != undefined){
          isActive.classList.remove('is-active');
        }

        this.classList.add('is-active');

        setTimeout(function(){
                document.addEventListener("scroll", scrollHandler, true); 
        }, 1000); 
      });
    }
	});




function scrollHandler() {


  var currentScrollPosition = document.documentElement.scrollTop;

	for (var i=1; i<=positionArray.length; i++){

		if (currentScrollPosition>=positionArray[i-1] && currentScrollPosition < positionArray[i]) {

        var currentActive = document.querySelectorAll(".menu-list a.is-active")[0];
            
				if (currentActive != undefined){
          currentActive.classList.remove('is-active');
        }
			
			quickLinks[i-1].classList.add('is-active');

			break;

		}

		if (currentScrollPosition>positionArray[positionArray.length-1]){

      var currentActive = document.querySelectorAll(".menu-list a.is-active")[0];

      if (currentActive != undefined){
        currentActive.classList.remove('is-active');
      }
      quickLinks[quickLinks.length-1].classList.add('is-active');

      break;

		}
	}
};


</script>

<style>

/* .is-horizonal-center{
  margin-left: auto;
  margin-right: auto;
  display: block;
}

.has-shadow{
  box-shadow: 0px 3px 6px #2F3E4D1A;;
}

.documentation section{

    margin-bottom: 4rem;;
} */

/* .main {
	scroll-behavior: smooth;
} */

p {
	margin-bottom: 25px;
}

.sticky	{
	position: sticky;
  top: 80px;
}

.content h2.title:not(:first-child) { 
  padding-top: 6rem; 
}



</style>

<svelte:head>
  <title>ZaaS - Documentation</title>
</svelte:head>

 <section class="main">

    <div class="container">

      <div class="columns">

        <div class="column content is-three-fifths">
          <h1 class="is-size-1 has-text-primary">Documentation</h1>
          <h2 id="introduction" class="title has-text-primary">Introduction</h2>

          <p>Integrating any application with ZaaS is identical to integrating a private ZofToken instance so most of the information is available in the <a href="https://zoftoken.com/doc" target="_blank">general documentation</a>. Conversely, using a free ZaaS subscription for experimenting and/or testing should be considered a good practice
          for implementing a private instance.
          </p>
          <p>Be aware that the “My Users” component of ZaaS is essentially a graphical frontend for the ZofToken API so every operation related to tokens (creating, checking and managing status, using the offline authentication and removing them) can be done both in the ZaaS UI or through the API.
          </p>
          
          <h2 id="integration"  class="title has-text-primary">Integration details</h2>
          <h5 class="is-secondary"><b>Usernames</b></h5 >
          <p>The username of each token as shown in ZaaS will be the “id” field in most API calls.
          </p>
          <h5 class="is-secondary"><b>Service names</b></h5 >
          <p>All services configured in ZaaS will be prefixed with your subscription name, so if subscription is called “testsubscription” and a service is called “testservice”, the “service” field in most API calls will have to be “testsubscription_testservice”. The ZaaS user interface clearly shows this in the “My Services” page.
          </p>
          <h5 class="is-secondary"><b>Authkeys</b></h5 >
          <p>Each service in ZaaS shows two authkeys (which can be copied directly to the system clipboard):</p>
              <ul>
                  <li>Basic: this authkey will only work to query a token status within that service through the API.
                  </li>
                  <li>Admin: this authkey will be allowed to perform all API operations for every token in the service.
                  </li>
              </ul>

          <h5 class="is-secondary"><b>API endpoints</b></h5 >
          <p>All API calls for ZaaS subscriptions need to be sent to the following URL:
          </p>
          <p><b>https://zaas.zoftoken.com/token</b>
          </p>

          <h2 id="examples" class="title has-text-primary">Examples</h2>

          <h5 class="is-secondary"><b>Configure Windows 10 PRO to use a ZofToken during the initial user login</b></h5>

                    <i>On the ZaaS side</i>
                        <ol>
                            <li>Create a service in the subscription with default parameters (using the machine name is recommended).</li>
                            <li>Create the user or users needed and complete the enrollment with the ZofToken app (the users need to be created with the same name that is used in Windows).
                            </li>
                        </ol>
                    
                    <i>On the Windows side</i>
                        
                        <ol>
                            <li>Create a text file (for example, with Notepad) with the following content:</li>

                        <div class="code-block">
                        <!-- HTML generated using hilite.me -->
<!-- <div style="background: #ffffff; overflow:auto;width:auto;border:solid gray;border-width:.1em .1em .1em .8em;padding:.2em .6em;"> -->
<pre style="margin: 0; line-height: 125%"><span style="color: #996633">$user</span> = <span style="color: #996633">$env:USERNAME</span>
<span style="color: #008800; font-weight: bold">if</span> (! <span style="color: #996633">$user</span>.Equals(<span style="background-color: #fff0f0">&quot;ONE&quot;</span>)) &lbrace;
  <span style="color: #996633">$wshell</span> = <span style="color: #007020">New-Object</span> -ComObject Wscript.Shell
  <span style="color: #003366; font-weight: bold">[Net.ServicePointManager]</span>::SecurityProtocol = <span style="color: #003366; font-weight: bold">[Net.SecurityProtocolType]</span>::Tls12
  <span style="color: #996633">$tokenCheck</span> = <span style="color: #007020">Invoke-WebRequest</span> -UseBasicParsing -Uri https://zaas.zoftoken.com/token/status<span style="color: #008800; font-weight: bold">?</span>id=<span style="color: #996633">$user</span><span style="background-color: #fff0f0">&quot;&amp;&quot;</span>service=TWO<span style="background-color: #fff0f0">&quot;&amp;&quot;</span>authKey=THREE
  <span style="color: #996633">$tokenStatus</span> = <span style="color: #996633">$tokenCheck</span>.Content.Substring(10,1)
  <span style="color: #008800; font-weight: bold">if</span> (! <span style="color: #996633">$tokenStatus</span>.Equals(<span style="background-color: #fff0f0">&quot;1&quot;</span>)) &lbrace;
    <span style="color: #996633">$wshell</span>.Popup(<span style="background-color: #fff0f0">&quot;Your ZofToken is currently closed - access to this account is denied&quot;</span>, 5)
    logoff
  }
}
</pre>
<!-- </div> -->

                           
                
<!-- <pre>
 <code class="javascript">
$user = $env:USERNAME
if (! $user.Equals("ONE")) &lbrace;
  $wshell = New-Object -ComObject Wscript.Shell
  [Net.ServicePointManager]::SecurityProtocol = [Net.SecurityProtocolType]::Tls12
  $tokenCheck = Invoke-WebRequest -UseBasicParsing -Uri https://zaas.zoftoken.com/token/status?id=$user"&"service=TWO"&"authKey=THREE
  $tokenStatus = $tokenCheck.Content.Substring(10,1)
  if (! $tokenStatus.Equals("1")) &lbrace;
    $wshell.Popup("Your ZofToken is currently closed - access to this account is denied", 5)
    logoff
  &rbrace;
&rbrace;
</code>
</pre> -->

                        </div>
                    
                            <li>Edit the parameters ONE, TWO and THREE as follows:
                                    <ul>
                                        <li>ONE: a username in your machine that will NOT have 2FA enabled - this is a contingency in case of any issues (e.g. no Internet access) preventing you from using ZofToken.
                                        </li>
                                        <li>TWO: the service name you configured earlier (for example, mysubscription_mypc).
                                        </li>
                                        <li>THREE: the “Basic Auth Key” that was randomly created earlier for the service.
                                        </li>
                                    </ul>
                            </li>    
                            <li>Save the file as “zoftoken.ps1” somewhere (for example, in your desktop).
                            </li>
                            <li>Open <b>Local Group Policy Editor</b>: go the Start Menu, type “Edit Group Policy” and click on it.
                            </li>
                            <ol>
                              <li>Go to Computer Configuration – Administrative Templates – Windows Components – Windows Powershell.
                              </li>
                              <li>Double click on “Turn on Script Execution” and once the new window appears, select “Enabled” (on the top left side), then select “Allow all scripts” (under Options: Execution Policy) and then click OK.
                              </li>
                              <li>Go back to the initial window, and now go to User Configuration – Windows Settings – Scripts (Logon/Logoff) – Logon.
                              </li>
                              <li>Go to the “PowerShell Scripts” tab.
                              </li>
                              <li>Click on “Show Files” at the bottom of the window and copy the file you created early into the folder that shows up (you might be asked for special administrator privileges, click OK).
                              </li>
                              <li>Back at the configuration window, click on Add, then click on Browse and select the “zoftoken.ps1” file you just copied, then click on OK.
                              </li>
                              <li>Click on Apply and then click on OK to close the window.
                              </li>
                            </ol>
                            <li>The next time any user logs in to the computer (except the contingency user you defined as parameter “ONE” earlier) they will need to have their ZofToken open, or they will receive a security warning and be logged off.
                            </li>
                        </ol>

          <h5 class="is-secondary"><b>Use a ZofToken to authorize deployments in a Continuous Integration tool</b></h5>

                    We released a publicly available plugin for Drone CI that can be included in any pipeline as an authorization/validation step.

                    <i>On the ZaaS side</i>
                        <ol>
                            <li>Create a service in the subscription with default parameters.</li>
                            <li>Create the user or users that will need to authorize the execution of Drone CI pipelines (usually deployments to live production services).
                            </li>
                        </ol>
                    
                    <i>On the Drone CI side</i>
                        <ul>
                            <li>The plugin is available at Dockerhub so it can be directly used as an image in Docker-based pipelines.</li>
                            <li>Please follow the <a href="https://hub.docker.com/r/zoftoken/drone">documentation</a> to configure your pipeline as needed.</li>
                        </ul>
        </div>
        <div class="column"></div>

        <div class="column">
          <div class="menu sticky is-documentation">
            <h4 class="menu-label is-size-6">Table of contents</h4>
            <ul id="menu" class="menu-list">
              <li><a href="#introduction">Introduction</a></li>
              <li><a href="#integration">Integration details</a></li>
              <li><a href="#examples">Examples</a></li>
            </ul>
          </div>
        </div>
      </div>
    </div> 
    <!-- end container -->

  </section>


